import React, { useEffect, useState } from 'react';
import './toggle-switch.scss';

interface ToggleSwitchProps {
  id: string;
  defaultChecked?: boolean;
  onChangeEmit: (data: { name: string; required: boolean; value: boolean }) => void;
}

export function ToggleSwitch(props: ToggleSwitchProps) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (props.defaultChecked !== null) {
      setChecked(props.defaultChecked ?? false);
    }
  }, [props.defaultChecked]);

  const handleChange = (event: any) => {
    const newStatus = event.target.checked;
    const dataToEmit = { name: props.id, required: false, value: newStatus };
    setChecked(newStatus);
    props.onChangeEmit(dataToEmit);
  };
  return (
    <>
      <div className="toggle-switch-container">
        <input type="checkbox" id={props.id} className="toggle-checkbox" checked={checked} onChange={handleChange} />
        <label htmlFor={props.id} className="toggle-label"></label>
      </div>
    </>
  );
}
